(() => {
  const KEY = 'PeakStyleProductCardCommerce';
  const VERSION = '1.3.0';
  if (window[KEY]?.version === VERSION) return;

  const BAG_ICON = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="f-icon-svg f-icon-svg--medium f-icon-shopping-bag" aria-hidden="true"><path d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.75 8.25C15.75 9.24456 15.3549 10.1984 14.6517 10.9017C13.9484 11.6049 12.9946 12 12 12C11.0054 12 10.0516 11.6049 9.34835 10.9017C8.64509 10.1984 8.25 9.24456 8.25 8.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setBagIcon(button) {
    if (!(button instanceof Element)) return;
    const icon = button.querySelector('.product-card__atc-icon, .product-card__quick-view-icon');
    if (!icon) return;
    if (icon.dataset.peakstyleBagIcon !== 'true') {
      icon.innerHTML = BAG_ICON;
      icon.dataset.peakstyleBagIcon = 'true';
    }
    icon.classList.remove('hidden');
  }

  function prepareCard(card) {
    if (!(card instanceof Element)) return;

    const addButtons = [...card.querySelectorAll('.product-card__atc')];
    const quickView = card.querySelector('.product-card__quickview[data-product-quickview]');
    const visibleButton = addButtons[0] || quickView;

    addButtons.forEach(button => {
      setBagIcon(button);
      button.classList.toggle('peakstyle-cart-icon-button', button === visibleButton);
      button.setAttribute(
        'aria-label',
        button.disabled ? 'Ausverkauft' : button.classList.contains('no-color-schema')
          ? 'Bestelloptionen anzeigen'
          : 'In den Warenkorb'
      );
    });

    if (quickView) {
      setBagIcon(quickView);
      const actsAsHelper = Boolean(addButtons.length);
      quickView.classList.toggle('peakstyle-cart-action-helper', actsAsHelper);
      quickView.classList.toggle('peakstyle-cart-icon-button', !actsAsHelper);
      quickView.setAttribute('aria-label', 'Bestelloptionen anzeigen');
    }

    const chooser = addButtons.find(button => button.classList.contains('no-color-schema'));
    if (chooser && quickView) {
      chooser.dataset.peakstyleOpenQuickview = 'true';
    }
  }

  function scan(root = document) {
    if (root instanceof Element && root.matches('.product-card')) prepareCard(root);
    root.querySelectorAll?.('.product-card').forEach(prepareCard);
  }

  function onClick(event) {
    const chooser = event.target.closest?.('[data-peakstyle-open-quickview="true"]');
    if (!chooser) return;

    const card = chooser.closest('.product-card');
    const quickView = card?.querySelector('.product-card__quickview[data-product-quickview]');
    if (!quickView || chooser === quickView) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    quickView.click();
  }

  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) scan(node);
      }
    }
  });

  function init() {
    scan();
    document.addEventListener('click', onClick, true);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window[KEY] = { version: VERSION, refresh: scan };
})();
